const localizers = {
  'loading.msg': () => `Загрузка...`,
  'logon.message.msg': () => `Требуется аутентификация. Введите допустимый идентификатор пользователя и пароль.`,
  'logon.button.msg': () => `Учетные данные...`,
  'SASServer.logonError.msg': () => `Невозможно войти на сервер.`,
  'SASServer.genericError.msg': () => `Невозможно связаться с сервером.`,
}
export default localizers;
